import { Alert, Button, message, Modal, Spin, Table } from "antd";
import React from "react";
import { ModalProps } from "antd/es/modal";
import useModalHandler from "../../../../../../../utils/v3/useModalHandler";
import styles from "./index.module.scss";
import useRequest from "../../../../../../../utils/useRequest";
import {
    findModelCount,
    ModelCountItem,
    queryRuleOrigin,
    RuleCountData,
    setRuleCount
} from "../../../../../../../service/score";
import { ColumnProps } from "antd/es/table";
import { CountField } from "../CountField";
import Form, { useForm } from "rc-field-form";
import useRequestFn from "../../../../../../../utils/useRequestFn";
import { errorMessage } from "../../../../../../../service/service";
import _ from "underscore";

interface CountModalButtonProps {
    courseNo: string;
    courseSeq: string;
}

export function CountModalButton({
    courseNo,
    courseSeq
}: CountModalButtonProps) {
    const modal = useModalHandler({ component: CountModal });
    const [data] = useRequest(() => queryRuleOrigin(courseNo, courseSeq));

    function onOk() {
        modal.close();
        window.location.reload();
    }

    return (
        <>
            {data?.id && (
                <Button
                    type="primary"
                    ghost
                    onClick={() => modal.open({ ruleId: data.id!, onOk })}>
                    自定义考核项次数维护
                </Button>
            )}

            {modal.render()}
        </>
    );
}

interface CountModalProps extends ModalProps {
    ruleId: number;
    onOk?(): void;
}

export function CountModal({ ruleId, onOk, ...props }: CountModalProps) {
    const [form] = useForm();
    const [data, { loading }] = useRequest(() => findModelCount(ruleId));

    const [onFinish, saveStatus] = useRequestFn(
        async (data: RuleCountData[]) => {
            try {
                await setRuleCount(
                    ruleId,
                    _.map(data, item => item)
                );
                message.success("保存成功!");
                onOk?.();
            } catch (e) {
                message.error(errorMessage(e));
            }
        }
    );

    const columns: ColumnProps<ModelCountItem>[] = [
        { title: "自定义考核项", dataIndex: "ruleModelName" },
        {
            title: "次数",
            dataIndex: "cnt",
            render: (cnt: number, item, index) => (
                <Form.Field name={[index]}>
                    <CountField />
                </Form.Field>
            )
        }
    ];

    return (
        <Modal
            {...props}
            title="自定义考核项次数维护"
            bodyStyle={{ padding: 0 }}
            onOk={form.submit}
            confirmLoading={saveStatus.loading}>
            <Alert
                message="说明:请填写自定义考核项目在其他平台或线下开展的实际次数"
                type="warning"
            />

            <Spin spinning={loading}>
                <div className={styles.body}>
                    {data && (
                        <Form
                            form={form}
                            onFinish={onFinish}
                            initialValues={data}>
                            <Table
                                rowKey="ruleModelName"
                                columns={columns}
                                dataSource={data || []}
                                pagination={false}
                            />
                        </Form>
                    )}
                </div>
            </Spin>
        </Modal>
    );
}
